// Sélection des éléments avec jQuery
var themeToggleDarkIcon = $('#theme-toggle-dark-icon');
var themeToggleLightIcon = $('#theme-toggle-light-icon');
var themeToggleBtn = $('#theme-toggle');

// Changer les icônes en fonction des paramètres précédents
if (localStorage.getItem('color-theme') === 'dark' || (!localStorage.getItem('color-theme') && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    themeToggleLightIcon.removeClass('hidden');
} else {
    themeToggleDarkIcon.removeClass('hidden');
}


// Écouteur d'événement pour le bouton de changement de thème
themeToggleBtn.on('click', function() {
    // Basculer l'icône à l'intérieur du bouton
    themeToggleDarkIcon.toggleClass('hidden');
    themeToggleLightIcon.toggleClass('hidden');

    // Si la valeur a déjà été définie dans localStorage
    if (localStorage.getItem('color-theme')) {
        if (localStorage.getItem('color-theme') === 'light') {
            $('html').addClass('dark');
            localStorage.setItem('color-theme', 'dark');
        } else {
            $('html').removeClass('dark');
            localStorage.setItem('color-theme', 'light');
        }
    // Si la valeur n'a pas été définie dans localStorage
    } else {
        if ($('html').hasClass('dark')) {
            $('html').removeClass('dark');
            localStorage.setItem('color-theme', 'light');
        } else {
            $('html').addClass('dark');
            localStorage.setItem('color-theme', 'dark');
        }
    }
});
